import React, { useState, useEffect } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import CalendarIcon from './icons/CalendarIcon';
import NavLink from './NavLink';
import User from './icons/User';
import InvoiceIcon from './icons/InvoiceIcon';
import CartIcon from './icons/CartIcon';
import Authorize from './Authorize';
import AccountIcon from './icons/Account';
import QuoteIcon from './icons/QuoteIcon';
import * as Roles from '../resources/UserRole';
import { withRouter } from 'react-router-dom';
import Warranty from './icons/Warranty';
import { withStorefrontConfig } from '../hooks/StorefrontSettingsContext';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



export const Navigation = (props) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true });
    const toggleMenu = () => {
        setMenuIsOpen(!menuIsOpen);
    };

    const menuRef = React.useRef(null);
    const menuIconRef = React.useRef(null);

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorAccount, setAnchorAccount] = React.useState(null);
    const accountOpen = Boolean(anchorAccount);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClickAccount = (event) => {
        setAnchorAccount(event.currentTarget);
    }
    const handleClose = () => {
        setAnchorEl(null);
        setAnchorAccount(null);
    };

    const showAdministrationMenu = () => {
        var menuItems = 0;
        var developer = Roles.DEVELOPER;
        if (props.currentUser.personaName === "StorefrontAdministrator") {
            menuItems++;
        }
        if (props.currentUser.roles.includes(developer)) {
            menuItems++;
        }
        return menuItems > 0;
    }

    useEffect(() => {
        if (!isMobile && menuIsOpen) {
            setMenuIsOpen(false);
        }
    }, [isMobile, menuIsOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuIsOpen &&
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                menuIconRef.current &&
                !menuIconRef.current.contains(event.target)
            ) {
                setMenuIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuIsOpen]);

    const localized = props.StorefrontConfig.labels;

        if (isMobile) {
            return (
                <div className="fele-navigation-mobile">
                    <button ref={menuIconRef} onClick={toggleMenu} style={{ background: "transparent", border: "none", height: "59px" }}>
                        <MenuIcon sx={{ fontSize: "5.4rem", color: "white" }} />
                    </button>

                    {menuIsOpen && (
                        <div ref={menuRef} data-cy="navigation"
                            style={{
                                position: "fixed",
                                top: "9.2rem",
                                left: 0,
                                width: "100vw",
                                background: "#172b42",
                                padding: "1rem",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                zIndex: 1061
                            }}
                        >
                            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                <NavLink
                                    url="/orders"
                                    caption={localized.OrderHistory}
                                    icon={<CalendarIcon />}
                                    onClick={() => setMenuIsOpen(false)}
                                />
                                <Authorize hasRoles={[Roles.VIEW_QUOTE_HISTORY]} displayMessage={false}>
                                    <NavLink
                                        url="/quotes"
                                        caption={localized.QuoteHistory}
                                        icon={<QuoteIcon />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.HAS_REPORTING]} displayMessage={false}>
                                    <NavLink
                                        url="/reporting"
                                        caption={localized.Reporting}
                                        icon={<InvoiceIcon />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.DEVELOPER, Roles.PLACE_ORDERS, Roles.PLACE_QUOTES]} displayMessage={false}>
                                    <NavLink
                                        url="/cart"
                                        caption={localized.QuickAdd}
                                        icon={<CartIcon />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.VIEW_INVOICE_HISTORY]} displayMessage={false}>
                                    <NavLink
                                        url="/invoices"
                                        caption={localized.Invoices}
                                        icon={<InvoiceIcon />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.VIEW_ACCOUNT_BALANCE]} displayMessage={false}>
                                    <NavLink
                                        url="/account"
                                        caption={localized.AccountBalance}
                                        icon={<AccountIcon />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.HAS_WARRANTY_ACCESS]} displayMessage={false}>
                                    <NavLink
                                        url="/claims"
                                        caption={localized.WarrantyClaims}
                                        icon={<Warranty />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize as={["Administrator", "CustomerAdministrator", "StorefrontAdministrator"]} displayMessage={false}>
                                    <NavLink
                                        url="/admin/users"
                                        caption={localized.Users}
                                        icon={<User />}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize as={["StorefrontAdministrator"]} displayMessage={false}>
                                    <NavLink
                                        url="/storefront-administration"
                                        caption="Storefront Administration"
                                        icon={<div className="icon" style={{ paddingRight: ".9rem" }}> <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 28 }} /> </div>}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                <Authorize hasRoles={[Roles.DEVELOPER]} displayMessage={false}>
                                    <NavLink
                                        url="/dcx-tooling"
                                        caption="DCX Tooling"
                                        icon={<div className="icon" style={{ paddingRight: ".9rem" }}> <DeveloperBoardIcon sx={{ fontSize: 28 }} /> </div>}
                                        onClick={() => setMenuIsOpen(false)}
                                    />
                                </Authorize>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div className={`fele-navigation ${menuIsOpen ? "open" : ""}`} ref={node => node = node} data-cy="navigation">
                <div className="ul">
                    <NavLink
                        url="/orders"
                        caption={localized.OrderHistory}
                        icon={<CalendarIcon />}
                    />
                    <Authorize hasRoles={[Roles.VIEW_QUOTE_HISTORY]} displayMessage={false}>
                        <NavLink
                            url="/quotes"
                            caption={localized.QuoteHistory}
                            icon={<QuoteIcon />}
                        />
                    </Authorize>
                    <Authorize hasRoles={[Roles.HAS_REPORTING]} displayMessage={false}>
                        <NavLink
                            url="/reporting"
                            caption={localized.Reporting}
                            icon={<InvoiceIcon />}
                        />
                    </Authorize>
                    <Authorize hasRoles={[Roles.DEVELOPER, Roles.PLACE_ORDERS, Roles.PLACE_QUOTES]} displayMessage={false}>
                        <NavLink
                            url="/cart"
                            caption={localized.QuickAdd}
                            icon={<CartIcon />}
                        />
                    </Authorize>
                    <>
                        <button
                            className="nav-item admin-trigger"
                            onClick={handleClickAccount}
                            aria-haspopup="true"
                            aria-expanded={accountOpen ? 'true' : 'false'}
                            aria-controls="account-menu"
                        >
                            <span className="icon" aria-hidden="true">
                                <AccountBalanceIcon sx={{ fontSize: 28 }} />
                            </span>
                            <span className="caption">{localized.AccountInformation}</span>
                            <span className={`caret ${accountOpen ? 'open' : ''}`} aria-hidden="true">
                                <ExpandMoreIcon />
                            </span>
                        </button>

                        <Menu
                            id="account-menu"
                            disablePortal
                            disableEnforceFocus
                            anchorEl={anchorAccount}
                            open={accountOpen}
                            onClose={handleClose}

                            MenuListProps={{
                                'aria-labelledby': 'account-menu',
                                dense: true,
                                sx: {
                                    p: 0,
                                    background: '#172b42',
                                    borderRadius: 0,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    '& > *': {
                                        display: 'block',
                                        width: '100%',
                                        textDecoration: 'none',
                                        '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
                                    },
                                },
                            }}

                            PaperProps={{
                                sx: {
                                    backgroundColor: '#172b42',
                                    boxShadow: 'none',
                                    borderRadius: 0,
                                    width: anchorAccount ? anchorAccount.offsetWidth : undefined,
                                },
                            }}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                        >
                            <Authorize hasRoles={[Roles.VIEW_INVOICE_HISTORY]} displayMessage={false}>
                                <NavLink
                                    url="/invoices"
                                    caption={localized.Invoices}
                                    icon={<InvoiceIcon />}
                                    onClick={handleClose}
                                />
                            </Authorize>
                            <Authorize hasRoles={[Roles.VIEW_ACCOUNT_BALANCE]} displayMessage={false}>
                                <NavLink
                                    url="/account"
                                    caption={localized.AccountBalance}
                                    icon={<AccountIcon />}
                                    onClick={handleClose}
                                />
                            </Authorize>
                        </Menu>
                    </>
                    
                    <Authorize hasRoles={[Roles.HAS_WARRANTY_ACCESS]} displayMessage={false}>
                        <NavLink
                            url="/claims"
                            caption={localized.WarrantyClaims}
                            icon={<Warranty />}
                        />
                    </Authorize>


                    {showAdministrationMenu() && (
                        <>
                            <button
                                className="nav-item admin-trigger"
                                onClick={handleClick}
                                aria-haspopup="true"
                                aria-expanded={open ? 'true' : 'false'}
                                aria-controls="administration-menu"
                            >
                                <span className="icon" aria-hidden="true">
                                    <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 28 }} />
                                </span>
                                <span className="caption">{localized.Administration}</span>
                                <span className={`caret ${open ? 'open' : ''}`} aria-hidden="true">
                                    <ExpandMoreIcon />
                                </span>
                            </button>

                            <Menu
                                id="administration-menu"
                                disablePortal
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}

                                MenuListProps={{
                                    'aria-labelledby': 'administration-menu',
                                    dense: true,
                                    sx: {
                                        p: 0,
                                        background: '#172b42',
                                        borderRadius: 0,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        '& > *': {
                                            display: 'block',
                                            width: '100%',
                                            textDecoration: 'none',
                                            '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)' },
                                        },
                                    },
                                }}
                               
                                PaperProps={{
                                    sx: {
                                        backgroundColor: '#172b42',
                                        boxShadow: 'none',
                                        borderRadius: 0,
                                        width: anchorEl ? anchorEl.offsetWidth : undefined,
                                    },
                                }}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                            >
                                <Authorize as={['Administrator', 'CustomerAdministrator', 'StorefrontAdministrator']} displayMessage={false}>
                                    
                                    <NavLink url="/admin/users"
                                        caption={localized.Users}
                                        icon={<User />}
                                        onClick={handleClose}
                                    />
                                   

                            </Authorize>
                                <Authorize as={['StorefrontAdministrator']} displayMessage={false}>

                                    
                                        <NavLink
                                            url="/storefront-administration"
                                        caption={localized.StorefrontAdministration}
                                            icon={
                                                <div className="icon" style={{ paddingRight: '.9rem' }}>
                                                    <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 28 }} />
                                                </div>
                                            }
                                            onClick={handleClose}
                                        />
                                    

                                </Authorize>
                                <Authorize hasRoles={[Roles.DEVELOPER]} displayMessage={false}>

                                    
                                        <NavLink
                                        url="/dcx-tooling"
                                        caption={localized.DeveloperTools}
                                            icon={
                                                <div className="icon" style={{ paddingRight: '.9rem' }}>
                                                    <DeveloperBoardIcon sx={{ fontSize: 28 }} />
                                                </div>
                                            }
                                            onClick={handleClose}
                                        />
                                    

                                </Authorize>
                            </Menu>
                        </>
                    )}

                    {!showAdministrationMenu() &&
                        <Authorize as={["Administrator", "CustomerAdministrator", "StorefrontAdministrator"]} displayMessage={false}>
                            <NavLink
                                url="/admin/users"
                                caption={localized.Users}
                                icon={<User />}
                            />
                        </Authorize>
                    }
                    {!showAdministrationMenu() &&
                        <Authorize as={["StorefrontAdministrator"]} displayMessage={false}>
                            <NavLink
                                url="/storefront-administration"
                                caption="Storefront Administration"
                                icon={<div className="icon" style={{ paddingRight: ".9rem" }}> <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 28 }} /> </div>}
                            />
                        </Authorize>
                    }
                    {!showAdministrationMenu() &&
                    <Authorize hasRoles={[Roles.DEVELOPER]} displayMessage={false}>
                        <NavLink
                            url="/dcx-tooling"
                            caption="DCX Tooling"
                            icon={<div className="icon" style={{ paddingRight: ".9rem" }}> <DeveloperBoardIcon sx={{ fontSize: 28 }} /> </div>}
                        />
                        </Authorize>
                    }
                </div>
            </div>
        )
    }

    Navigation.propTypes = {
        currentUser: PropTypes.object,
        history: PropTypes.object.isRequired
    }
    function mapStateToProps(state) {
        return {
            currentUser: state.user.currentUser,
        };
    }

    export default compose(
        withRouter,
        connect(mapStateToProps)
    )(withStorefrontConfig(Navigation));
